import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone.js";
import utc from "dayjs/plugin/utc.js";
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * Date du jour à Paris, au format `YYYY-MM-DD`. Un seul appel par requête ou
 * par passage de cron : deux appels dans la même exécution peuvent tomber de
 * part et d'autre de minuit Paris.
 */
export function todayParis(now = new Date()) {
    return dayjs(now).tz("Europe/Paris").format("YYYY-MM-DD");
}
/**
 * `churnedAt` et `today` sont des dates (`YYYY-MM-DD`), jamais des instants —
 * la comparaison de strings suffit et évite tout piège de fuseau horaire.
 */
export function isChurned(churnedAt, today) {
    return churnedAt !== null && churnedAt <= today;
}
//# sourceMappingURL=churn.js.map